<template>
  <CardModule untitle>
    <v-form ref="form" class="search-forms" @submit.prevent="filterProducts()">
      <v-row>
        <v-col cols="12" md="3" sm="4">
          <BaseTextField
            :label="$t('events.event-description')"
            :placeholder="$t('events.insert-event-description')"
            v-model="description"
          />
        </v-col>
        <v-col cols="12" md="3" sm="4">
          <BaseSelect
            :items="$produtos_gerenciar.categorias_produtos"
            item-text="descricao"
            item-value="idcategoria"
            :label="$t('events.category')"
            :attach="false"
            clearable
            v-model="category"
          >
          </BaseSelect>
        </v-col>
        <v-col class="d-flex justify-end">
          <BaseButton variant="filter" type="submit" :loading="loadingEvents">
            {{ $t("events.filter") }}
          </BaseButton>
        </v-col>
      </v-row>
    </v-form>

    <v-expand-transition>
      <v-row class="mt-4" v-if="haveProducts">
        <v-col cols="12" sm="6">
          <h4 class="text-center mb-3">{{ $t("events.ordering.ordered") }}</h4>
          <v-data-table
            :headers="headers"
            mobile-breakpoint="0"
            hide-default-footer
          >
            <template v-slot:body="props">
              <draggable
                group="order"
                :list="props.items"
                tag="tbody"
                @end="onDragEndOrder"
              >
                <tr v-for="(item, index) in paginatedOrder" :key="index">
                  <td style="text-align: center; min-width: 100px">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-on="on"
                          v-bind="attrs"
                          icon
                          small
                          height="30"
                          style="cursor: grab"
                        >
                          <v-icon>mdi-drag</v-icon>
                        </v-btn>
                      </template>
                      <span>{{ $t("events.ordering.drag-to-order") }}</span>
                    </v-tooltip>
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-on="on"
                          v-bind="attrs"
                          :color="$config.dados.corinputs"
                          height="30"
                          small
                          icon
                          @click="moveItemToStart(index)"
                        >
                          <v-icon>mdi-arrow-up-bold</v-icon>
                        </v-btn>
                      </template>
                      <span>{{ $t("events.ordering.move-to-top") }}</span>
                    </v-tooltip>
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-on="on"
                          v-bind="attrs"
                          :color="$config.dados.corinputs"
                          height="30"
                          small
                          icon
                          @click="moveItemToEnd(index)"
                        >
                          <v-icon>mdi-arrow-down-bold</v-icon>
                        </v-btn>
                      </template>
                      <span>{{ $t("events.ordering.move-to-top") }}</span>
                    </v-tooltip>
                  </td>
                  <td class="py-2" style="text-align: center; width: 100%">
                    {{ item.descricao }}
                  </td>
                </tr>
              </draggable>
            </template>
            <template v-slot:footer>
              <v-pagination
                v-model="currentPageOrder"
                v-if="totalOrderedEvents > 0"
                :total-visible="5"
                :length="Math.ceil(totalOrderedEvents / itemsPerPageOrder)"
                @input="onPageChangeOrder"
                circle
                color="tertiary"
              />
            </template>
          </v-data-table>
        </v-col>

        <v-col cols="12" sm="6">
          <h4 class="mb-3 text-center">
            {{ $t("events.ordering.unordered") }}
            <v-tooltip top max-width="200" height="100" color="transparent">
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="ml-2" icon x-small v-bind="attrs" v-on="on">
                  <InfoIcon />
                </v-btn>
              </template>
              <v-card color="tooltip-card black">
                <v-card-text class="text-white">
                  {{ $t("events.ordering.unordered-info") }}
                </v-card-text>
              </v-card>
            </v-tooltip>
          </h4>
          <v-data-table
            :headers="headers"
            mobile-breakpoint="0"
            hide-default-footer
          >
            <template v-slot:body="props">
              <draggable
                group="order"
                @end="onDragEnd"
                :list="props.items"
                tag="tbody"
              >
                <tr
                  v-for="(item, index) in paginatedOrderUndefined"
                  :key="index"
                >
                  <td
                    class="handle"
                    style="text-align: center; min-width: 100px"
                  >
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-on="on"
                          v-bind="attrs"
                          icon
                          small
                          height="30"
                          style="cursor: grab"
                        >
                          <v-icon>mdi-drag</v-icon>
                        </v-btn>
                      </template>
                      <span>{{ $t("events.ordering.drag-to-order") }}</span>
                    </v-tooltip>
                  </td>
                  <td style="text-align: center; width: 100%">
                    {{ item.descricao }}
                  </td>
                </tr>
              </draggable>
            </template>
            <template v-slot:footer>
              <v-pagination
                v-if="totalUnorderedEvents > 0"
                v-model="currentPageOrderUndefined"
                :total-visible="5"
                :length="
                  Math.ceil(totalUnorderedEvents / itemsPerPageOrderUndefined)
                "
                @input="onPageChangeOrderUndefined"
                circle
                color="tertiary"
              />
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-expand-transition>
  </CardModule>
</template>
<script>
import CardModule from "@/components/cards/CardModule.vue";
import BaseTextField from "@/components/forms/BaseTextField.vue";
import BaseSelect from "@/components/forms/BaseSelect.vue";
import BaseButton from "@/components/forms/BaseButton.vue";
import draggable from "vuedraggable";
import mixins from "@/mixins";
import { mapActions, mapGetters } from "vuex";

const { formRules } = mixins;
export default {
  name: "ecommerceOrder",
  mixins: [formRules],
  data() {
    return {
      description: "",
      category: "",
      loadingEvents: false,
      currentPageOrder: 1,
      itemsPerPageOrder: 10,
      currentPageOrderUndefined: 1,
      itemsPerPageOrderUndefined: 10,
    };
  },
  components: {
    CardModule,
    BaseTextField,
    BaseSelect,
    BaseButton,
    draggable,
    InfoIcon: () => import("@/components/icons/InfoIcon.vue"),
  },
  computed: {
    ...mapGetters([
      "orderedEvents",
      "unorderedEvents",
      "totalOrderedEvents",
      "totalUnorderedEvents",
    ]),
    headers() {
      return [
        {
          text: this.$t("events.actions"),
          value: "code",
          align: "center",
          width: "100px",
        },
        {
          text: this.$t("events.description"),
          value: "descricao",
          align: "center",
          width: "100px",
        },
      ];
    },
    isAdmin() {
      if (this.$axios.getLocal("oe_user_info")?.data?.user_type === "admin")
        return true;
      return false;
    },
    haveProducts() {
      if (this.orderedEvents.length > 0 || this.unorderedEvents.length > 0)
        return true;
      return false;
    },
    paginatedOrder() {
      return this.orderedEvents;
    },
    paginatedOrderUndefined() {
      return this.unorderedEvents;
    },
  },
  methods: {
    ...mapActions(["fetchOrderEvents", "reorderEvents"]),
    async filterProducts() {
      this.currentPageOrder = 1;
      this.currentPageOrderUndefined = 1;
      this.loadingEvents = true;
      await this.fetchOrderEvents({
        ord_limite: this.itemsPerPageOrder,
        ord_pagina: this.currentPageOrder,
        nao_ord_limite: this.itemsPerPageOrderUndefined,
        nao_ord_pagina: this.currentPageOrderUndefined,
        descricao: this.description,
        idcategoria: this.category,
      });
      this.loadingEvents = false;
    },
    async onDragEnd(evt) {
      if (evt.to !== evt.from) {
        const movedItemIndex = evt.oldIndex;
        const replaceItemIndex = evt.newIndex;
        const movedItem = this.unorderedEvents.splice(movedItemIndex, 1)[0];
        const replaceItem = this.orderedEvents.splice(replaceItemIndex, 1)[0];

        if (replaceItem) {
          await this.reorderEvents({
            idproduto: movedItem.idproduto,
            idcombo: movedItem.idcombo,
            ordem: replaceItem.ordem_venda_wl,
          });
        } else if (this.orderedEvents.length === 0) {
          await this.reorderEvents({
            idproduto: movedItem.idproduto,
            idcombo: movedItem.idcombo,
            ordem: 1,
          });
        } else {
          await this.reorderEvents({
            idproduto: movedItem.idproduto,
            idcombo: movedItem.idcombo,
            ult_pos: true,
          });
        }
        this.filterProducts();
      } else {
        this.$config.alert(
          "Não é possível ordenar entre os não ordenados",
          this.$config.dados.errorColor
        );
        return;
      }
    },
    async onDragEndOrder(evt) {
      if (evt.to !== evt.from) {
        const movedItemIndex = evt.oldIndex;
        const movedItem = this.orderedEvents.splice(movedItemIndex, 1)[0];
        await this.reorderEvents({
          idproduto: movedItem.idproduto,
          idcombo: movedItem.idcombo,
          ordem: 9999999999,
        });
      } else {
        const movedItemIndex = evt.oldIndex;
        const replaceItemIndex = evt.newIndex;
        const movedItem = this.orderedEvents.splice(movedItemIndex, 1)[0];
        const replaceItem = this.orderedEvents.splice(replaceItemIndex, 1)[0];

        if (replaceItem) {
          await this.reorderEvents({
            idproduto: movedItem.idproduto,
            idcombo: movedItem.idcombo,
            ordem: replaceItem.ordem_venda_wl,
          });
        } else {
          await this.reorderEvents({
            idproduto: movedItem.idproduto,
            idcombo: movedItem.idcombo,
            ult_pos: true,
          });
        }
      }
      this.filterProducts();
    },
    findLastOrder() {
      let lastOrder = 0;
      this.orderedEvents.forEach(product => {
        if (product.ordem_venda_wl > lastOrder) {
          lastOrder = product.ordem_venda_wl;
        }
      });
      return lastOrder;
    },
    async moveItemToEnd(index) {
      const movedItemIndex = index;
      const movedItem = this.orderedEvents.splice(movedItemIndex, 1)[0];

      await this.reorderEvents({
        idproduto: movedItem.idproduto,
        idcombo: movedItem.idcombo,
        ult_pos: true,
      });

      this.filterProducts();
    },
    async moveItemToStart(index) {
      const movedItemIndex = index;
      const movedItem = this.orderedEvents.splice(movedItemIndex, 1)[0];

      await this.reorderEvents({
        idproduto: movedItem.idproduto,
        idcombo: movedItem.idcombo,
        ordem: 1,
      });
      this.filterProducts();
    },
    searchLoja(array, search) {
      let pesquisa = this.replaceSpecialChars(
        search.toString().toLocaleLowerCase().normalize("NFD")
      );
      let palavra = this.replaceSpecialChars(
        array.nome_loja.toString().toLocaleLowerCase().normalize("NFD")
      );

      if (palavra.indexOf(pesquisa) != -1) {
        return array;
      }
    },
    replaceSpecialChars(str) {
      str = str.replace(/[ÀÁÂÃÄÅ]/, "A");
      str = str.replace(/[àáâãäå]/, "a");
      str = str.replace(/[ÈÉÊË]/, "E");
      str = str.replace(/[Ç]/, "C");
      str = str.replace(/[ç]/, "c");
      // o resto
      return str.replace(/[^a-z0-9]/gi, "");
    },
    async onPageChangeOrder(page) {
      this.currentPageOrder = page;
      await this.fetchOrderEvents({
        ord_limite: this.itemsPerPageOrder,
        ord_pagina: this.currentPageOrder,
        nao_ord_limite: this.itemsPerPageOrderUndefined,
        nao_ord_pagina: this.currentPageOrderUndefined,
        descricao: this.description,
        idcategoria: this.category,
      });
    },
    async onPageChangeOrderUndefined(page) {
      this.currentPageOrderUndefined = page;
      await this.fetchOrderEvents({
        ord_limite: this.itemsPerPageOrder,
        ord_pagina: this.currentPageOrder,
        nao_ord_limite: this.itemsPerPageOrderUndefined,
        nao_ord_pagina: this.currentPageOrderUndefined,
        descricao: this.description,
        idcategoria: this.category,
      });
    },
  },
  watch: {},
  beforeMount() {
    this.fetchOrderEvents({
      ord_limite: this.itemsPerPageOrder,
      ord_pagina: this.currentPageOrder,
      nao_ord_limite: this.itemsPerPageOrderUndefined,
      nao_ord_pagina: this.currentPageOrderUndefined,
    });
    this.$produtos_gerenciar.getProdutosCategoria();
  },
};
</script>
<style scoped>
.text-white {
  color: white !important;
  text-align: center;
}
.tooltip-card {
  position: relative;
}
.tooltip-card:after {
  content: "";
  width: 15px;
  height: 15px;
  position: absolute;
  bottom: -0.8rem;
  right: 50%;
  transform: rotate(180deg) translateX(-50%);
  background-color: rgb(0, 0, 0);
  clip-path: polygon(50% 0%, 0% 100%, 100% 100%);
}
</style>
